import {styled} from '@esgi/ui/theme';
import {FlexBox} from '@esgi/ui/layout';

export const Layout = styled(FlexBox, {
	flexDirection: 'column',
	background: `#F5F5F5`,
	height: '100%',
	width: '100%',
});